export const ApiPath = (process.env.NODE_ENV === 'production') ? "/api" : "http://localhost:3001/api";
export const ImgPath = "https://res.cloudinary.com/hcwueczff/image/upload";